export default __webpack_public_path__ + "static/media/closeLightGrey.e2ef2ca2.svg";